import { create } from "zustand";

type DeviceDialogStore = {
    isOpen: boolean;
    openAssignment: () => void;
    close: () => void;
};

export const useDeviceDialogStore = create<DeviceDialogStore>((set) => ({
    isOpen: false,
    data: undefined,
    openAssignment: () =>
        set(() => ({
            isOpen: true
        })),
    close: () => {
        set(() => ({ isOpen: false}));
        setTimeout(() => {}, 100);
    },
}));